import { INSUFFICIENT_CREDITS_ERROR } from '../../../arweaveUpload.constants';

function isArDriveInsufficientCreditsError(error: unknown): boolean {
  const message = error instanceof Error ? error.message.toLowerCase() : '';
  const status = (error as { status?: number }).status;

  return (
    status === 402 ||
    message.includes('402') ||
    message.includes('insufficient balance')
  );
}

export function throwIfArDriveInsufficientCredits(error: unknown): void {
  if (isArDriveInsufficientCreditsError(error)) {
    throw new Error(INSUFFICIENT_CREDITS_ERROR);
  }
}
